import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useQuery } from "@apollo/client/react";

import type { RestaurantFetch } from "../../types/restaurantTypes";
import type { UseOptions } from "../hookTypes"
import { ADDRESS_FRAGMENT } from "../../fragments/address";

const FETCH_RESTAURANT = gql`
  query FetchRestaurant($id: ID!) {
    restaurant(id: $id) {
      id
      name
      phone
      website
      wifi
      img {
        small
        medium
      }
      address { ...AddressFragment }
    }
  }
  ${ADDRESS_FRAGMENT}
`; 

const useRestaurant = (id: string | number | undefined, options?: UseOptions) => {
  const { fetchPolicy = "cache-and-network", refetchOnMount = false } = options ?? {};

  const { data, loading, error, refetch } = useQuery<RestaurantFetch>(FETCH_RESTAURANT, {
    variables: { id: String(id) },
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });

  if (refetchOnMount && !loading) {
    refetch();
  }

  const restaurant = data?.restaurant;

  const refetchRestaurant = useCallback(async () => {
    try {
      await refetch();
    } catch {
      // log if need
    }
  }, [refetch]);

  return {
    restaurant,
    loading,
    error: error as Error | null | undefined,
    refetchRestaurant,
  };
}

export default useRestaurant
